import { initialCheckoutRatesState, CHECKOUT_RATES_ACTIONS } from './checkoutRates.types'

/**
 *
 * @param {import('./checkoutRates.types').CheckoutRatesSlice} state
 * @param {import('./checkoutRates.types').CheckoutRatesAction} action
 * @returns
 */
export function checkoutRatesReducer(state = initialCheckoutRatesState, { type, payload }) {
  switch (type) {
    case CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_STATUS:
      return { ...state, status: payload }

    case CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_RATES:
      return { ...state, rates: payload }

    case CHECKOUT_RATES_ACTIONS.SET_CHECKOUT_RATES_SELECTED_RATE:
      return { ...state, selectedRate: payload }

    case CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_ERRORS:
      return { ...state, errors: [] }

    case CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_RATES:
      return { ...state, rates: [] }

    case CHECKOUT_RATES_ACTIONS.CLEAR_CHECKOUT_RATES_SELECTED_RATE:
      return { ...state, selectedRate: null, selectedRatesByGroup: {} }

    case CHECKOUT_RATES_ACTIONS.SET_SELECTED_RATE_FOR_GROUP:
      return {
        ...state,
        selectedRatesByGroup: {
          ...state.selectedRatesByGroup,
          [payload.groupId]: payload.rate
        }
      }

    case CHECKOUT_RATES_ACTIONS.SET_CALCULATION_ID:
      return { ...state, calculationId: payload }

    case CHECKOUT_RATES_ACTIONS.SET_SHIPPING_RATE_LOG_ID:
      return { ...state, shippingRateLogId: payload }

    case CHECKOUT_RATES_ACTIONS.SET_IS_CALCULATING:
      return { ...state, isCalculating: payload }

    case CHECKOUT_RATES_ACTIONS.SET_CALCULATION_PROGRESS:
      return { ...state, calculationProgress: payload }

    case CHECKOUT_RATES_ACTIONS.SET_CONFIGURATION_ID:
      return { ...state, configurationId: payload }

    case CHECKOUT_RATES_ACTIONS.SET_SHIPPING_PAYMENT_METHOD:
      return { ...state, shippingPaymentMethod: payload }

    case CHECKOUT_RATES_ACTIONS.SET_THIRD_PARTY_BILLING_DATA:
      return { ...state, thirdPartyBillingData: payload }

    default:
      return state
  }
}
